import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    carouselId: string;
    relatedProductType: string;
    productId?: string;
    isShellEdit?: boolean;
}

interface Props {
    getProductCollectionParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
    additionalSort?: (products: ProductModel[]) => ProductModel[];
}

type HandlerType = Handler<Parameter, Props>;

export const LoadRelatedProducts: HandlerType = props => {
    const {
        parameter: { relatedProductType: relationship, productId },
    } = props;

    props.getProductCollectionParameter = { productId, relationship, pageSize: 999 };
};

export const LoadProducts: HandlerType = ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, isShellEdit },
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay: 999,
          }
        : undefined;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges")
        : (getProductCollectionParameter.expand = ["images", "badges"]);

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            isShellEdit,
            additionalSort,
        }),
    );
};

export const chain = [LoadRelatedProducts, LoadProducts];

const loadCmiProducts = createHandlerChainRunner(chain, "LoadCmiProducts");
export default loadCmiProducts;
